/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import PageScaffold from '../../components/app/page-scaffold'
import {BaseLayout} from '../../components/layout'
import {routes} from '../../utils/config'

const Troubleshooting = () => {
  return (
    <BaseLayout>
      <PageScaffold pageTitle={routes.troubleshooting.name} />
    </BaseLayout>
  )
}

export default Troubleshooting
